import { styled } from 'goober';
import { forwardRef } from 'react';
var columnGap = '20px';
var rowHeight = '24px'; //must be >= font
// kpi custom styled components:
export var KPIColHeader = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'relative',
        zIndex: 1,
        paddingBottom: '2px',
        '&:hover div.kpi-col-header-btns': {
            opacity: 1,
        },
        '&:hover div.uncollapse-btns': {
            opacity: 1,
        },
    });
});
export var KPIColHeaderTitle = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        textAlign: 'right',
        fontWeight: 600,
        fontSize: '12px',
        height: '12px',
        marginBottom: '4px',
        whiteSpace: 'nowrap',
        paddingLeft: columnGap,
    });
});
export var KPIColHeaderSubitle = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        textAlign: 'right',
        //opacity: 0.4,
        color: theme.colors.neutral.w700,
        fontSize: '12px',
        height: '12px',
        marginBottom: '2px',
        paddingLeft: columnGap,
    });
});
export var KPITitleHeaderBtns = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        opacity: 0,
        display: 'flex',
        position: 'absolute',
        transition: 'opacity ease 0.3s',
        zIndex: 3,
        bottom: 0,
    });
});
export var KPITitleHeaderBtn = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        padding: '0px 5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.colors.neutral.w100,
        },
    });
});
export var KPIColHeaderBtns = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        opacity: 0,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        position: 'absolute',
        backgroundColor: '#fff',
        border: "1px solid ".concat(theme.colors.neutral.w300),
        borderRadius: theme.borderRadius,
        boxShadow: 'rgb(107 131 160 / 15%) 0px 4px 16px',
        top: '20px',
        right: 0,
        transition: 'opacity ease 0.3s',
        zIndex: 3,
    });
});
export var KPIColHeaderBtn = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        padding: '5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: theme.colors.neutral.w100,
        },
    });
});
export var KPIHeaderResizer = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'absolute',
        right: '-5px',
        cursor: 'col-resize',
        width: '10px',
        height: '100%',
        top: 0,
    });
});
export var KPIColInfoLabel = styled('span')(function (_a) {
    var theme = _a.theme;
    return ({
        gridColumn: '1 / span 3',
        fontSize: '12px',
        padding: '5px',
        fontWeight: 100,
    });
});
export var KPIRowTitle = styled('div')(function (_a) {
    var theme = _a.theme, $depth = _a.$depth, $isTableOption = _a.$isTableOption;
    return ({
        paddingLeft: "".concat($depth * 20, "px"),
        cursor: 'pointer',
        height: rowHeight,
        display: 'flex',
        alignItems: 'center',
        fontSize: '12px',
        color: $isTableOption ? theme.colors.primary.w500 : theme.colors.ui.dark,
        div: {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            paddingRight: '5px',
        },
    });
});
export var KPIRowCell = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        position: 'relative',
        justifyContent: 'flex-end',
        alignItems: 'center',
        paddingLeft: columnGap,
        height: rowHeight,
        fontSize: '12px',
    });
});
// conditional formatting of kpi columns:
export var ConditionalFormatting = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'absolute',
        top: 0,
        height: '100%',
        width: '100%',
        textAlign: 'right',
    });
});
export var TrafficLights = styled(ConditionalFormatting)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
    });
});
export var TrafficLightsInner = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        marginLeft: '15px',
    });
});
export var DataBar = styled(ConditionalFormatting)(function (_a) {
    var theme = _a.theme;
    return ({
        paddingLeft: columnGap,
    });
});
export var DataBarInner = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        height: '100%',
        width: '100%',
        backgroundColor: '#b4c6e7',
        borderTop: '2px solid #fff',
        borderBottom: '2px solid #fff',
    });
});
export var ColorScale = styled(ConditionalFormatting)(function (_a) {
    var theme = _a.theme;
    return ({
        paddingLeft: columnGap,
    });
});
export var ColorScaleInner = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        height: '100%',
        width: '100%',
    });
});
export var Arrows = styled(ConditionalFormatting)(function (_a) {
    var theme = _a.theme, $color = _a.$color;
    return ({
        paddingBottom: '2px',
        paddingTop: '2px',
        fontSize: '12px',
        color: $color,
    });
});
// kpi grid (well... not quite 'grid', more like powerful combo of grid & flex 'cos grid wasn't enough):
export var GridContainer = styled('div', forwardRef)(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'grid',
        overflow: 'auto',
        height: '100%',
        width: '100%',
    });
});
export var Grid = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'flex',
        flexWrap: 'nowrap',
    });
});
export var GridCol = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        width: 'auto',
        minWidth: 'auto',
    });
});
export var GridColFixedLeft = styled(GridCol)(function (_a) {
    var theme = _a.theme, _b = _a.$width, $width = _b === void 0 ? 300 : _b;
    return ({
        position: 'sticky',
        left: 0,
        zIndex: 2,
        background: 'white',
        display: 'flex',
        flexDirection: 'column',
        //flexGrow: 1,
        //minWidth: 'auto',
        width: "".concat($width, "px"),
        borderRight: "2px solid ".concat(theme.borderColor),
    });
});
export var GridItem = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        lineHeight: 1.2,
    });
});
export var GridItemHeader = styled(GridItem)(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'sticky',
        background: 'white',
        top: 0,
        zIndex: 1,
        borderBottom: "2px solid ".concat(theme.borderColor),
        marginBottom: '4px',
        minWidth: '85px',
        width: 'auto',
        maxWidth: 'auto',
    });
});
